// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/FAQ.css */
.faq-section {
    padding: 100px 0;
    background: linear-gradient(to right, #114040 0%, #144c4c 100%);
    color: #dcca98;
  }
  
  .faq-section h2 {
    color: #dcca98;
    text-align: center;
    margin-bottom: 50px;
    position: relative;
    font-size: 2.5em;
    font-weight: bold;
  }
  
  .faq-section h2::after {
    position: absolute;
    content: "";
    background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);
    height: 4px;
    width: 60px;
    bottom: -10px;
    margin-left: -30px;
    left: 50%;
  }
  
  .faq-categories {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .category-header {
    padding: 20px;
    background-color: #dcca98;
    color: #114040;
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .category-header:hover {
    background-color: #efd899;
    transform: translateY(-2px);
  }
  
  .faq-container {
    max-width: 800px;
    margin: 20px auto 0;
  }
  
  .faq-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 5px;
    background-color: #4b9c8e;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-weight: bold;
  }
  
  .faq-item:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
  
  .faq-item.open {
    background-color: #3b7c6e;
  }
  
  .faq-icon {
    width: 40px;
    height: 40px;
    margin-right: 15px;
    transition: transform 0.3s ease;
    font-weight: bold;
  }
  
  .faq-item.open .faq-icon {
    transform: rotate(315deg);
  }
  
  .faq-content {
    flex-grow: 1;
  }
  
  .faq-question {
    font-size: 1.2em;
    color: #ffffff;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .faq-answer {
    font-size: 1em;
    color: #ffffff;
    line-height: 1.5;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/home/FAQ.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,+DAA+D;IAC/D,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,+DAA+D;IAC/D,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2DAA2D;IAC3D,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":["/* src/components/FAQ.css */\n.faq-section {\n    padding: 100px 0;\n    background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n    color: #dcca98;\n  }\n  \n  .faq-section h2 {\n    color: #dcca98;\n    text-align: center;\n    margin-bottom: 50px;\n    position: relative;\n    font-size: 2.5em;\n    font-weight: bold;\n  }\n  \n  .faq-section h2::after {\n    position: absolute;\n    content: \"\";\n    background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);\n    height: 4px;\n    width: 60px;\n    bottom: -10px;\n    margin-left: -30px;\n    left: 50%;\n  }\n  \n  .faq-categories {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  .category-header {\n    padding: 20px;\n    background-color: #dcca98;\n    color: #114040;\n    text-align: center;\n    font-size: 1.5em;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.3s ease;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  .category-header:hover {\n    background-color: #efd899;\n    transform: translateY(-2px);\n  }\n  \n  .faq-container {\n    max-width: 800px;\n    margin: 20px auto 0;\n  }\n  \n  .faq-item {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 20px;\n    padding: 15px;\n    border-radius: 5px;\n    background-color: #4b9c8e;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    color: #ffffff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-weight: bold;\n  }\n  \n  .faq-item:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    transform: translateY(-2px);\n  }\n  \n  .faq-item.open {\n    background-color: #3b7c6e;\n  }\n  \n  .faq-icon {\n    width: 40px;\n    height: 40px;\n    margin-right: 15px;\n    transition: transform 0.3s ease;\n    font-weight: bold;\n  }\n  \n  .faq-item.open .faq-icon {\n    transform: rotate(315deg);\n  }\n  \n  .faq-content {\n    flex-grow: 1;\n  }\n  \n  .faq-question {\n    font-size: 1.2em;\n    color: #ffffff;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  .faq-answer {\n    font-size: 1em;\n    color: #ffffff;\n    line-height: 1.5;\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
